import { Component } from '@angular/core';
import { InvoicePatientCashDeskService } from '../../../services/invoice-cash-desk/invoice-patient-cash-desk.service';
import { InvoiceCashDeskService } from '../../../services/invoice-cash-desk/invoice-cash-desk.service';
import { AdmissionPreReceptionWizardService, AdmissionReceptionWizardService, AdmissionWizardService } from '../../../services/wizard/admission/admission.wizzard.service';

@Component({
  selector: 'app-admission-pre-reception-wizard-component',
  templateUrl: './admission-pre-reception-wizard.component.html',
  styleUrls: ['./admission-pre-reception-wizard.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoicePatientCashDeskService }
    , { provide: AdmissionWizardService, useClass: AdmissionPreReceptionWizardService }]
  })
export class AdmissionPreReceptionWizardComponent  {

}
